import { isAndroidCapacitor } from './platformUtils';

/** Desktop leaderboard breakpoint (728×90). Below this, phone uses responsive in-feed. */
export const DESKTOP_GRID_MIN_MQ = '(min-width: 720px)';
export const DESKTOP_GRID_3COL_MQ = '(min-width: 720px)';
export const DESKTOP_GRID_4COL_MQ = '(min-width: 1100px)';

/**
 * AdSense Display unit for in-feed 728×90 leaderboards (desktop web ≥720px).
 * Create a Leaderboard (728×90) unit in AdSense and paste the slot id.
 */
export const DESKTOP_GRID_AD_SLOT = '3922005466';

/**
 * AdSense Display unit for phone/tablet web in-feed (<720px).
 * Prefer a horizontal / large mobile banner unit (≈320×100) — not a fluid auto unit.
 * Temporary: reuses former browse footer slot until a dedicated mobile in-feed unit exists.
 */
export const MOBILE_GRID_AD_SLOT = '3216091167';

/** Insert a full-width ad row after this many item rows on desktop web (≥720px). */
export const DESKTOP_GRID_AD_ROW_INTERVAL = 3;

/** Insert a full-width ad row after this many item rows on phone web + Capacitor in-feed. */
export const MOBILE_GRID_AD_ROW_INTERVAL = 5;

/** Row interval for the current viewport (phone vs desktop). */
export function getFeedGridAdRowInterval(isDesktop = isDesktopGridBreakpoint()) {
    return isDesktop ? DESKTOP_GRID_AD_ROW_INTERVAL : MOBILE_GRID_AD_ROW_INTERVAL;
}

/** Web in-feed ads (phone + desktop). Capacitor uses AdMob in-feed instead. */
export function shouldShowWebGridAds() {
    if (typeof window === 'undefined') return false;
    if (isAndroidCapacitor?.() === true) return false;
    return true;
}

/** Feed grid ad rows on web (AdSense) or Capacitor (AdMob). */
export function shouldShowFeedGridAds() {
    if (typeof window === 'undefined') return false;
    return true;
}

/** @deprecated Prefer shouldShowWebGridAds + isDesktopGridBreakpoint */
export function shouldShowDesktopGridAds() {
    if (!shouldShowWebGridAds()) return false;
    return window.matchMedia(DESKTOP_GRID_MIN_MQ).matches;
}

export function isDesktopGridBreakpoint() {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(DESKTOP_GRID_MIN_MQ).matches;
}

/** Column count matching .msv-item-grid / .infinite-feed-grid breakpoints. */
export function getDesktopGridColumnCount() {
    if (typeof window === 'undefined') return 2;
    if (window.matchMedia(DESKTOP_GRID_4COL_MQ).matches) return 4;
    if (window.matchMedia(DESKTOP_GRID_3COL_MQ).matches) return 3;
    return 2;
}

/**
 * Build mixed feed cells: items plus a full-width ad row after every N item rows.
 * Does not drop items - ads are extra cells that span all columns.
 */
export function buildDesktopGridCells(
    items,
    {
        columns = 4,
        rowInterval = DESKTOP_GRID_AD_ROW_INTERVAL,
        enabled = true,
    } = {}
) {
    if (!enabled || !columns || !rowInterval) {
        return items.map((item, index) => ({ type: 'item', item, index }));
    }

    const itemsBeforeAd = columns * rowInterval;
    const cells = [];

    items.forEach((item, index) => {
        cells.push({ type: 'item', item, index });
        if ((index + 1) % itemsBeforeAd === 0) {
            cells.push({ type: 'ad', key: `grid-ad-row-${index}` });
        }
    });

    return cells;
}
